<div class="section enjoy-section d-flex flex-column align-items-center justify-content-center" [style.background-image]="'url(' + ('/banners/Bt_ImgInt_Conceito.png' | bucket) + ')'">
  <div class="title-footer">Aproveite a experiência bodytech</div>
  <a routerLink="/academias" class="btn btn-primary">Conheça nossas academias</a>
</div>
